<script lang="ts">
  // Bottom sheet: scrim + `role=dialog` panel with grip and title, focus-trapped.
  // Escape is handled by the App-level cascade (spec §17), the scrim click closes.
  import type { Snippet } from 'svelte';
  import { focusTrap } from '$lib/util/dom';

  let {
    label,
    title = label,
    cls = '',
    onclose,
    children,
  }: {
    label: string;
    title?: string;
    cls?: string;
    onclose: () => void;
    children: Snippet;
  } = $props();
</script>

<div class="scrim" role="presentation" aria-hidden="true" onclick={onclose}></div>
<div class="sheet {cls}" role="dialog" aria-modal="true" aria-label={label} use:focusTrap>
  <div class="grip"></div>
  <h3>{title}</h3>
  {@render children()}
</div>

<style>
  /* @css ui/Sheet start */
  .scrim {
    position: fixed;
    inset: 0;
    background: var(--scrim);
    backdrop-filter: blur(2px);
    z-index: var(--z-overlay)
  }

  .sheet {
    position: fixed;
    inset-inline: 0;
    bottom: 0;
    inline-size: min(560px, 100%);
    margin-inline: auto;
    background: var(--surface-card);
    border-radius: var(--radius-panel) var(--radius-panel) 0 0;
    box-shadow: var(--shadow-dialog);
    padding: var(--space-2) var(--space-3) calc(var(--space-4) + env(safe-area-inset-bottom));
    z-index: var(--z-layer);
    max-height: 70dvh;
    overflow-y: auto;
    overscroll-behavior: contain;
    animation: svelte-1n46o8q-sheet-in .22s var(--ease-out)
  }

  .grip {
    width: 36px;
    height: 4px;
    border-radius: var(--radius-pill);
    background: var(--border-strong);
    margin: var(--space-2) auto var(--space-3)
  }

  .sheet h3 {
    font-size: var(--text-sm);
    color: var(--text-muted);
    padding: 0 var(--space-3) var(--space-2)
  }

  @keyframes svelte-1n46o8q-sheet-in {
    0% {
      transform: translateY(24px);
      opacity: 0
    }
  }
  /* @css ui/Sheet end */
</style>
